import VideoEmbed from "./_components/video-embed";

export default VideoEmbed;
